import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GameModeService } from '../../../_services/game-mode.service';
import { GameAudioService } from '../../../_services/game-audio.service';
import { GameQuestion } from '../../../interfaces/question.interface';
import { ClassCreature } from '../../../interfaces/creature.interface';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-quiz-container',
  templateUrl: './quiz-container.component.html',
  styleUrls: ['./quiz-container.component.scss']
})
export class QuizContainerComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  currentQuestion: GameQuestion | null = null;
  creature: ClassCreature | null = null;
  timerValue = 30;
  questionNumber = 0;
  totalQuestions = 0;
  selectedOption: 'A' | 'B' | 'C' | 'D' | null = null;
  isSubmitting = false;
  currLang: any = 'en';

  constructor(
    private gameModeService: GameModeService,
    private globalService: GlobalService,
    private gameAudioService: GameAudioService
  ) {}

  ngOnInit(): void {
    this.gameModeService.currentQuestion$
      .pipe(takeUntil(this.destroy$))
      .subscribe(q => {
        this.currentQuestion = q;
        this.selectedOption = null;
        this.isSubmitting = false;
        if (q) {
          this.gameAudioService.startCountdownAudio(this.gameModeService.timerValue$);
        }
      });

    this.gameModeService.quizSession$
      .pipe(takeUntil(this.destroy$))
      .subscribe(session => {
        if (session) {
          this.questionNumber = session.currentIndex + 1;
          this.totalQuestions = session.questions.length;
        }
      });

    this.gameModeService.timerValue$
      .pipe(takeUntil(this.destroy$))
      .subscribe(v => this.timerValue = v);

    this.gameModeService.creature$
      .pipe(takeUntil(this.destroy$))
      .subscribe(c => this.creature = c);

    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);
  }

  ngOnDestroy(): void {
    this.gameAudioService.stopCountdownAudio();
    this.gameModeService.stopQuizTimer();
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectOption(optionId: 'A' | 'B' | 'C' | 'D'): void {
    if (this.isSubmitting) return;
    this.selectedOption = optionId;
  }

  submitAnswer(): void {
    if (!this.selectedOption || this.isSubmitting) return;
    this.gameAudioService.stopCountdownAudio();
    this.isSubmitting = true;
    this.gameModeService.submitAnswer(this.selectedOption);
  }

  getRyderQuizTip(): string {
    if (this.selectedOption) {
      return this.currLang === 'ar' ? 'متأكد؟ أرسل إجابتك!' : 'Confident? Submit your answer!';
    }
    return this.currLang === 'ar' ? 'فكّر جيداً...' : 'Think carefully...';
  }
}
